<aa-collaborative-network-and-activities-list
  [activities]="activities"
  [collaborations]="collaborations"
  [currentViewType]="collaborativeNetworkAndActivitiesListCurrentView"
  [nodeClassGenerator]="nodeClassGenerator"
  (nodeClicked)="showRelevancyCollaborationsDialog($event)"
  (currentViewTypeChange)="onViewTypeChange($event)"
  [showCollaborativeGraphHeader]="true"
  [showCollaboratorCountTooltip]="true"
  [collaboratorCountToolTipText]="
    'Set the maximum number of collaborators displayed for each scholar (up to 50)'
  "
  [collaboratorCount]="collaboratorCount$ | async"
  [showTopScholarsInGraphHeader]="false"
  [lazyLoadScholars]="true"
  [maxScholarsToDisplay]="maxScholarsToDisplay"
  [forceMapPeople]="forceMapPeople"
  (collaboratorCountChange)="collaboratorCount$.next($event)"
  (showAllPeopleChange)="showPeople($event)"
  (showAllScholarsClick)="showAllCollaborators($event)"
>
</aa-collaborative-network-and-activities-list>
